// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__euqEC","buttons":"Footer_buttons__37S8S"};